import { NodeSelection, TextSelection } from '@tiptap/pm/state'
import { Editor } from '@tiptap/react/src/Editor'

// TODO update deps
// see https://github.com/ueberdosis/tiptap/issues/2979
export function isNodeSelection(value: unknown): value is NodeSelection {
  return value instanceof NodeSelection
}
// see https://github.com/ueberdosis/tiptap/issues/2979
export function isTextSelection(value: unknown): value is TextSelection {
  return value instanceof TextSelection
}

export function clearSelection(editor: Editor): void {
  const noneSelection = new TextSelection(editor.state.doc.resolve(0))
  editor.view.dispatch(editor.state.tr.setSelection(noneSelection))
}

export function getSelectedText(editor: Editor): string | null {
  const { from, to, empty } = editor.state.selection

  if (empty) return null

  return editor.state.doc.textBetween(from, to, ' ')
}
